import { render, staticRenderFns } from "./OperelInvoiceItemActions.vue?vue&type=template&id=5c5488c0&scoped=true&"
import script from "./OperelInvoiceItemActions.vue?vue&type=script&lang=ts&"
export * from "./OperelInvoiceItemActions.vue?vue&type=script&lang=ts&"
import style0 from "./OperelInvoiceItemActions.vue?vue&type=style&index=0&id=5c5488c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5488c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabItem})
